
import { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: "How long does the international expansion process typically take?",
      answer: "The timeline varies depending on your business complexity and target markets, but most clients see their first international sales within 6-8 weeks. Our complete expansion process typically takes 3-6 months from strategy to full implementation."
    },
    {
      question: "What's included in the free strategy session?",
      answer: "Your free 30-minute consultation includes a business assessment, market opportunity analysis, identification of potential challenges, and a high-level roadmap for your expansion. You'll leave with actionable insights regardless of whether you choose to work with us."
    },
    {
      question: "Do you work with businesses of all sizes?",
      answer: "We primarily work with small to medium-sized businesses generating $100K+ in annual revenue. However, we evaluate each opportunity individually. If you're a startup with strong growth potential, we'd love to discuss your goals."
    },
    {
      question: "What markets do you specialize in?",
      answer: "We have deep expertise in North America, Europe, Asia-Pacific, and emerging markets in Latin America and the Middle East. Our team has successfully launched businesses in over 25 countries across all major continents."
    },
    {
      question: "How do you handle different regulations and compliance requirements?",
      answer: "Regulatory compliance is one of our core strengths. We have partnerships with legal experts in each market and maintain up-to-date knowledge of international trade regulations, tax requirements, and industry-specific compliance needs."
    },
    {
      question: "What if my business doesn't succeed in international markets?",
      answer: "While we can't guarantee success, our 98% success rate speaks to our methodology. We conduct thorough market research upfront and provide ongoing optimization to maximize your chances of success. We're committed to your long-term growth."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Get answers to common questions about our international expansion services.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between"
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
              >
                <span className="font-semibold text-gray-900">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform ${
                  openFAQ === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 py-4 bg-white">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help.
          </p>
          <button className="text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap">
            Contact us directly →
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
